import NewsPage from 'marketing/news';

export default NewsPage;
